// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-usageBarChart-module__container--uJqFw {
  border-radius: 4px;
  background-color: #071c35;
  padding: 0px;
  margin: 15px 0;
  overflow-x: auto;
  overflow-y: visible;
  position: relative;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__header--v4nPw {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 10px;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__title--iFDAq {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__bartitle--unV7F {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__subtitle--bQf4i {
  font-size: 12px;
  color: #9b9b9b;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC {
  background-color: #919AA4;
  border-radius: 4px;
  padding: 8px;
}

/* Override dc-chart background to match wrapper (removes the in-between color band) */
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .dc-chart {
  background-color: #919AA4;
}

/* Style dc.js chart elements */
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC svg {
  background-color: #919AA4;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .axis text {
  fill: #071c35;
  font-size: 11px;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .dc-chart g.axis.x text,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .axis.x text,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .dc-chart g.axis.y text,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .axis.y text {
  fill: #0D1117;
  font-family: Montserrat;
  font-size: 11px;
  font-weight: 500;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .axis line,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .axis path {
  stroke: #FDFDFD;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .grid-line line {
  stroke: #FDFDFD !important;
  
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .bar rect,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC rect.bar,
.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .bar {
  fill: #4169e1;
  stroke: none;
  stroke-width: 0;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC .dc-legend {
  display: none;
}

.d3-tip {
  background: rgba(0, 0, 0, 0.75) !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  padding: 8px 12px !important;
  border-radius: 6px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.d3-tip-arrow:after {
  color: rgba(0, 0, 0, 0.75) !important;
}

.d3-tip-arrow.e:after {
  content: "\\25C0" !important;
  position: absolute;
  top: 50%;
  left: -5px;
  transform: translateY(-50%);
  margin: 0 !important;
  width: auto !important;
  text-align: left;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__footer--YtYws {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  gap: 4px;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__legend--r6xMv {
  display: flex;
  align-items: center;
  gap: 6px;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__legendDot--Ib5KE {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #4169e1;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__legendText--M5jYS {
  font-size: 13px;
  color: #0D1117;
}

.src-js-pages-usageReportingContainer-components-usageBarChart-module__xAxisLabel--dgk5L {
  font-size: 12px;
  color: #0D1117;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/usageBarChart.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,sFAAsF;AACtF;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,0BAA0B;;AAE5B;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".container {\n  border-radius: 4px;\n  background-color: #071c35;\n  padding: 0px;\n  margin: 15px 0;\n  overflow-x: auto;\n  overflow-y: visible;\n  position: relative;\n}\n\n.header {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.bartitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.subtitle {\n  font-size: 12px;\n  color: #9b9b9b;\n}\n\n.chartWrapper {\n  background-color: #919AA4;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n/* Override dc-chart background to match wrapper (removes the in-between color band) */\n.chartWrapper :global(.dc-chart) {\n  background-color: #919AA4;\n}\n\n/* Style dc.js chart elements */\n.chartWrapper :global(svg) {\n  background-color: #919AA4;\n}\n\n.chartWrapper :global(.axis text) {\n  fill: #071c35;\n  font-size: 11px;\n}\n\n.chartWrapper :global(.dc-chart g.axis.x text),\n.chartWrapper :global(.axis.x text),\n.chartWrapper :global(.dc-chart g.axis.y text),\n.chartWrapper :global(.axis.y text) {\n  fill: #0D1117;\n  font-family: Montserrat;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.chartWrapper :global(.axis line),\n.chartWrapper :global(.axis path) {\n  stroke: #FDFDFD;\n}\n\n.chartWrapper :global(.grid-line line) {\n  stroke: #FDFDFD !important;\n  \n}\n\n.chartWrapper :global(.bar rect),\n.chartWrapper :global(rect.bar),\n.chartWrapper :global(.bar) {\n  fill: #4169e1;\n  stroke: none;\n  stroke-width: 0;\n}\n\n.chartWrapper :global(.dc-legend) {\n  display: none;\n}\n\n:global(.d3-tip) {\n  background: rgba(0, 0, 0, 0.75) !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  padding: 8px 12px !important;\n  border-radius: 6px;\n  line-height: 1.4;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n:global(.d3-tip-arrow:after) {\n  color: rgba(0, 0, 0, 0.75) !important;\n}\n\n:global(.d3-tip-arrow.e:after) {\n  content: \"\\25C0\" !important;\n  position: absolute;\n  top: 50%;\n  left: -5px;\n  transform: translateY(-50%);\n  margin: 0 !important;\n  width: auto !important;\n  text-align: left;\n}\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px;\n  gap: 4px;\n}\n\n.legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.legendDot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #4169e1;\n}\n\n.legendText {\n  font-size: 13px;\n  color: #0D1117;\n}\n\n.xAxisLabel {\n  font-size: 12px;\n  color: #0D1117;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-js-pages-usageReportingContainer-components-usageBarChart-module__container--uJqFw`,
	"header": `src-js-pages-usageReportingContainer-components-usageBarChart-module__header--v4nPw`,
	"title": `src-js-pages-usageReportingContainer-components-usageBarChart-module__title--iFDAq`,
	"bartitle": `src-js-pages-usageReportingContainer-components-usageBarChart-module__bartitle--unV7F`,
	"subtitle": `src-js-pages-usageReportingContainer-components-usageBarChart-module__subtitle--bQf4i`,
	"chartWrapper": `src-js-pages-usageReportingContainer-components-usageBarChart-module__chartWrapper--it0qC`,
	"footer": `src-js-pages-usageReportingContainer-components-usageBarChart-module__footer--YtYws`,
	"legend": `src-js-pages-usageReportingContainer-components-usageBarChart-module__legend--r6xMv`,
	"legendDot": `src-js-pages-usageReportingContainer-components-usageBarChart-module__legendDot--Ib5KE`,
	"legendText": `src-js-pages-usageReportingContainer-components-usageBarChart-module__legendText--M5jYS`,
	"xAxisLabel": `src-js-pages-usageReportingContainer-components-usageBarChart-module__xAxisLabel--dgk5L`
};
export default ___CSS_LOADER_EXPORT___;
